import React from 'react';

/**
 * Lightweight inline SVG icons to replace FontAwesome in eagerly-loaded components.
 * This avoids pulling the entire FA core (~25KB gzipped) into the main bundle.
 */
const icons = {
  sliders: (
    <path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z" />
  ),
  search: (
    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" />
  ),
  sun: (
    <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c12.8-6.4 12.8-24.6 0-31z" />
  ),
  moon: (
    <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z" />
  ),
  facebook: (
    <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
  ),
  bluesky: (
    <path d="M180.734 4.085C218.09 32.818 257.795 91.085 271.999 118.59c14.204-27.505 53.91-85.772 91.266-114.505C384.213-12.18 448 -3.16 448 49.54c0 10.53-6.063 88.477-9.62 101.096-12.385 43.892-57.518 55.1-97.712 48.328 70.243 11.835 88.108 51.058 49.538 90.281C326.792 344.366 278.79 295.478 272 251.19c-6.79 44.288-54.792 93.095-118.206 38.055-38.57-39.223-20.705-78.446 49.538-90.281-40.194 6.772-85.327-4.436-97.712-48.328C101.064 138.017 95 60.07 95 49.54c0-52.7 63.787-61.72 85.734-45.455z" />
  ),
};

const viewBoxMap = {
  sliders: '0 0 512 512',
  search: '0 0 512 512',
  sun: '0 0 512 512',
  moon: '0 0 512 512',
  facebook: '0 0 512 512',
  bluesky: '0 0 543 512',
};

const Icon = ({ name, className = '', style = {}, size }) => {
  const sizeStyle = size ? { width: size, height: size } : {};
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBoxMap[name] || '0 0 512 512'}
      className={className}
      style={{ display: 'inline-block', height: '1em', verticalAlign: '-0.125em', fill: 'currentColor', ...sizeStyle, ...style }}
    >
      {icons[name]}
    </svg>
  );
};

export default Icon;
